import httpClient from '../httpClient';

const getAll = async () => {
  return await httpClient.get(`/country/?sort=name`);
};

const getOnlyTrue = async () => {
  return await httpClient.get(`/country/?sort=name&filter[status]=true`);
};

export {
  getAll,
  getOnlyTrue,
};